import api from '../../api/index.js'

const state = {
    
}

const getters = {
    
}

const actions = {
    WeiXinPay({commit},payload){
        return new Promise((resolve, reject) => {
            api.post('/Pay/WeiXinPay',payload, res => {
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    },
}

const mutations = {
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/pay.js